import { Injectable } from '@angular/core';

@Injectable()
export class debtordocumenttype {
   public documenttype : any [] = [
        { value:'DNI', name: 'DNI' },
        { value:'RUC', name: 'RUC' },
        { value:'CEX', name: 'CEX' },
        { value:'OTHER', name: 'OTROS' },
      ];

    constructor() { }
  }

  @Injectable()
export class debtorTipo {
    public dbtTipo : any [] = [
        { value:0, name: 'TODOS' },
        { value:1, name: 'Compañias' },
        { value:2, name: 'Personas' }       
      ];

    constructor() { }
  }

  @Injectable()
  export class debtorStatus {
      public Status : any [] = [         
          { value:'ACTIVE', name: 'Activo' },
          { value:'INACTIVE', name: 'Inactivo' }       
        ];
  
      constructor() { }
    }

    @Injectable()
    export class debtorPhonePrefix {
        public PhonePrefix : any [] = [         
            { value:'+1', name: '+1' },
            { value:'+51', name: '+51' }       
          ];
    
        constructor() { }
      }


      @Injectable()
    export class currencysymbolPrefix {
        public currencyPrefix : any [] = [         
            { value:'S/.', name: 'S/.' },
            { value:'US$', name: 'US$' }       
          ];
    
        constructor() { }
      }

      @Injectable()
      export class DocumentService {
        private documents = [
            {
              "name" : "Documento Nacional de Identificación",
              "short_name" : "DNI",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Registro Único del Contribuyente",
              "short_name" : "RUC",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Carnet de Extranjería",
              "short_name" : "CEX",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Pasaporte",
              "short_name" : "PAS",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Permiso Temporal de Permanencia",
              "short_name" : "PTP",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Otros",
              "short_name" : "OTHER",
              "iso_alpha_3" : "PER",
              "iso_alpha_2" : "PE"
            },
            {
              "name" : "Documento Nacional de Identificación",
              "short_name" : "DNI",
              "iso_alpha_3" : "ARG",
              "iso_alpha_2" : "AR"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "CI",
              "iso_alpha_3" : "BOL",
              "iso_alpha_2" : "BO"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "CI",
              "iso_alpha_3" : "BOL",
              "iso_alpha_2" : "BO"
            },
            {
              "name" : "Registro Geral",
              "short_name" : "RG",
              "iso_alpha_3" : "BRA",
              "iso_alpha_2" : "BR"
            },
            {
              "name" : "Cadastro de Pessoas Físicas",
              "short_name" : "CPF",
              "iso_alpha_3" : "BRA",
              "iso_alpha_2" : "BR"
            },
            {
              "name" : "Rol Único Tributario",
              "short_name" : "RUT",
              "iso_alpha_3" : "CHL",
              "iso_alpha_2" : "CL"
            },
            {
              "name" : "Registro único nacional",
              "short_name" : "RUN",
              "iso_alpha_3" : "CHL",
              "iso_alpha_2" : "CL"
            },
            {
              "name" : "Registro único nacional",
              "short_name" : "RUN",
              "iso_alpha_3" : "CHL",
              "iso_alpha_2" : "CL"
            },
            {
              "name" : "Cédula de Ciudadanía",
              "short_name" : "Cédula",
              "iso_alpha_3" : "COL",
              "iso_alpha_2" : "CO"
            },
            {
              "name" : "Tarjeta de Identidad",
              "short_name" : "TI",
              "iso_alpha_3" : "COL",
              "iso_alpha_2" : "CO"
            },
            {
              "name" : "Cédula de extranjería",
              "short_name" : "CEX",
              "iso_alpha_3" : "COL",
              "iso_alpha_2" : "CO"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "Cédula",
              "iso_alpha_3" : "ECU",
              "iso_alpha_2" : "EC"
            },
            {
              "name" : "Registro Único de Contribuyentes",
              "short_name" : "RUC",
              "iso_alpha_3" : "ECU",
              "iso_alpha_2" : "EC"
            },
            {
              "name" : "Pasaporte",
              "short_name" : "Pasaport",
              "iso_alpha_3" : "ECU",
              "iso_alpha_2" : "EC"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "Cédula",
              "iso_alpha_3" : "PRY",
              "iso_alpha_2" : "PY"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "Cédula",
              "iso_alpha_3" : "PRY",
              "iso_alpha_2" : "PY"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "Cédula",
              "iso_alpha_3" : "URY",
              "iso_alpha_2" : "UY"
            },
            {
              "name" : "Cédula de Identidad",
              "short_name" : "Cédula",
              "iso_alpha_3" : "VEN",
              "iso_alpha_2" : "VE"
            },
            {
              "name" : "Registro de Información Fiscal",
              "short_name" : "RIF",
              "iso_alpha_3" : "VEN",
              "iso_alpha_2" : "VE"
            },
            {
              "name" : "Instituto Nacional Electoral",
              "short_name" : "INE",
              "iso_alpha_3" : "MEX",
              "iso_alpha_2" : "MX"
            },
            {
              "name" : "Clave Única de Registro de Población",
              "short_name" : "CURP",
              "iso_alpha_3" : "MEX",
              "iso_alpha_2" : "MX"
            },
            {
              "name" : "Registro Federal de Contribuyentes",
              "short_name" : "RFC",
              "iso_alpha_3" : "MEX",
              "iso_alpha_2" : "MX"
            },
            {
              "name": "Social Security Number",
              "short_name": "SSN",
              "iso_alpha_3": "USA",
              "iso_alpha_2": "US"
            },
            {
              "name": "Driver's License",
              "short_name": "DL",
              "iso_alpha_3": "USA",
              "iso_alpha_2": "US"
            },
            {
              "name": "Passport",
              "short_name": "PAS",
              "iso_alpha_3": "USA",
              "iso_alpha_2": "US"
            },
            {
              "name": "Permanent Resident Card",
              "short_name": "Green Card",
              "iso_alpha_3": "USA",
              "iso_alpha_2": "US"
            }
        ];
        
        private prefix = [
          {
              "name": "Perú",
              "prefix": "+51",
              "iso_alpha_3": "PER",
              "iso_alpha_2": "PE"
          },
          {
              "name": "Argentina",
              "prefix": "+54",
              "iso_alpha_3": "ARG",
              "iso_alpha_2": "AR"
          },
          {
              "name": "Bolivia",
              "prefix": "+591",
              "iso_alpha_3": "BOL",
              "iso_alpha_2": "BO"
          },
          {
              "name": "Brasil",
              "prefix": "+55",
              "iso_alpha_3": "BRA",
              "iso_alpha_2": "BR"
          },
          {
              "name": "Chile",
              "prefix": "+56",
              "iso_alpha_3": "CHL",
              "iso_alpha_2": "CL"
          },
          {
              "name": "Colombia",
              "prefix": "+57",
              "iso_alpha_3": "COL",
              "iso_alpha_2": "CO"
          },
          {
              "name": "Ecuador",
              "prefix": "+593",
              "iso_alpha_3": "ECU",
              "iso_alpha_2": "EC"
          },
          {
              "name": "Paraguay",
              "prefix": "+595",
              "iso_alpha_3": "PRY",
              "iso_alpha_2": "PY"
          },
          {
              "name": "Uruguay",
              "prefix": "+598",
              "iso_alpha_3": "URY",
              "iso_alpha_2": "UY"
          },
          {
              "name": "Venezuela",
              "prefix": "+58",
              "iso_alpha_3": "VEN",
              "iso_alpha_2": "VE"
          },
          {
              "name": "México",
              "prefix": "+52",
              "iso_alpha_3": "MEX",
              "iso_alpha_2": "MX"
          },
          {
            "name": "United States",
            "prefix": "+1",
            "iso_alpha_3": "USA",
            "iso_alpha_2": "US"
          }          
        ];
        
        getDocumentsByIsoAlpha2(data?: string) {
          if (!data) {
            return this.documents;
          }
          const filteredDocuments = this.documents.filter(doc => doc.iso_alpha_2 === data.toUpperCase());
          return filteredDocuments.length > 0 ? filteredDocuments : this.documents;
        }

        getPrefixByIsoAlpha2(data?: string) {
          if (!data) {
            return this.prefix;
          }
          const filteredDocuments = this.prefix.find(pref => pref.iso_alpha_2 === data.toUpperCase());
          return filteredDocuments;
        }

        getPhoneNumberOnly(value: string): string {
          for (const country of this.prefix) {
              if (value.startsWith(country.prefix)) {
                  return value.slice(country.prefix.length);
              }
          }
          return value;
        }
  
        getCountryCode(value: string): string | undefined {
            for (const country of this.prefix) {
                if (value.startsWith(country.prefix)) {
                    return country.prefix;
                }
            }
            return value;
        }
      }
